import {ReferenceDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'CREATE_REFERENCE';

export async function createReference(
    userData: Record<string, string>,
    reference: Record<string, any>
) {
    try {
        const result = await ReferenceDao.createReference(userData.userToken, reference);

        return result;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
